import { CommonModule } from "@angular/common"
import { Component, Input } from "@angular/core"

@Component({
  selector: 'app-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  @Input() title = ''
  constructor() {}
}
